import React, { useEffect, useRef } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import styles from '../../../../../styles/expenditureworksheet.module.css';
import { NumericFormat } from 'react-number-format';

const ReceiptQuickAdd = ({ types, add }) => {
    const { control, register, handleSubmit, reset, setFocus, formState: { errors } } = useForm({ defaultValues: { typequickadd: -1, detailquickadd: '', amountquickadd: 0.00 } });

    const _onSubmit = (data, e) => {

        const value = {
            id: crypto.randomUUID(),
            type: data.typequickadd,
            detail: data.detailquickadd,
            amount: data.amountquickadd
        }

        add(value);

        setFocus('typequickadd');

        reset({ typequickadd: -1, detailquickadd: '', amountquickadd: 0.00 });
    }

    const _validateSelect = (values) => {
        if (values === -1) {
            return '*Type is required.'
        }

        return true;
    }

    return (

        <div className="mb-3">
            <Row className="">
                <Col xs={12} md={4} className="mb-1">
                    <label htmlFor="typequickadd" className="visually-hidden">Type</label>
                    <select id="typequickadd" {...register('typequickadd', { valueAsNumber: true, validate: _validateSelect })} style={{ width: '100%', height: '32px' }}>
                        <option value={-1} disabled >Select a type</option>
                        {
                            types.map((item, index) => (
                                <option key={index} value={item.id}>{item.name}</option>
                            ))
                        }
                    </select>
                    {errors.typequickadd && <small style={{ color: 'red' }}>{errors.typequickadd.message}</small>}
                </Col>
                <Col xs={12} md={5} className="mb-1">
                    <label htmlFor="detailquickadd" className="visually-hidden">Detail</label>
                    <input placeholder="Details" type="text" id="detailquickadd" {...register('detailquickadd', { required: '*Details is required' })} style={{ width: '100%', height: '32px' }} />
                    {errors.detailquickadd && <small style={{ color: 'red' }}>{errors.detailquickadd.message}</small>}
                </Col>
                <Col xs={12} md={2} className="mb-1">
                    <label htmlFor="amountquickadd" className="visually-hidden">Amount</label>
                    <Controller
                        name="amountquickadd"
                        control={control}
                        rules={{
                            validate: (values) => {

                                if (values !== undefined && values !== null) {
                                    if (values < 0.01)
                                        return "*Amount is required."
                                    return true;
                                }
                                else {
                                    return "*Amount is required."
                                }
                            }
                        }}
                        render={({ field }) => (
                            <NumericFormat value={field.value} id="amountquickadd" placeholder="Amount" style={{ width: '100%', height: '32px' }} prefix={'$'} decimalScale={2} fixedDecimalScale={true} allowNegative={false} onValueChange={(values) => field.onChange(values.floatValue)} />
                        )}
                    />
                    {errors.amountquickadd && <small style={{ color: 'red' }}>{errors.amountquickadd.message}</small>}
                    {/* <label htmlFor="amountquickadd" className="visually-hidden">Amount</label>
                    <input placeholder="$ Amount" type="text" onChange={_handleCurrencyChange} value={formattedValue} id="amountquickadd" {...register('amountquickadd')} style={{width: '100%', height: '32px'}} /> */}
                </Col>
                <Col xs={12} md={1} className="mb-1">
                    <div className="d-flex align-items-center justify-content-center">
                        <Button type="submit" variant="success" size="sm" className={styles.quickAddButton} onClick={handleSubmit(_onSubmit)}>
                            <FontAwesomeIcon icon={faPlus} size="xl" />
                        </Button>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default ReceiptQuickAdd;